import {
  apiService,
  createRequestHeadersConfig,
  NestedApiResponse} from 'shared/api'
import { capitalizeWords } from 'shared/utils/common'

import {
  CustomerAddress,
  CustomerDeliveryAddressPayload,
  CustomerInvoiceAddress,
  CustomerInvoiceAddressPayload
} from './types'

const api = apiService()

const capitalizeDeliveryAddressPayload = (
  payload: CustomerDeliveryAddressPayload
) => {
  return {
    ...payload,
    city: capitalizeWords(payload.city)
  }
}

export const addDeliveryAddress = (
  payload: CustomerDeliveryAddressPayload,
  token?: string
) =>
  api.post<NestedApiResponse<CustomerAddress>>(
    '/addresses',
    capitalizeDeliveryAddressPayload(payload),
    createRequestHeadersConfig(token)
  )

export const editCustomerDeliveryAddress = (
  id: string,
  payload: CustomerDeliveryAddressPayload,
  token?: string
) =>
  api.patch<NestedApiResponse<CustomerAddress>>(
    `/addresses/${id}`,
    capitalizeDeliveryAddressPayload(payload),
    createRequestHeadersConfig(token)
  )

export const deleteDeliveryAddress = (id: string, token?: string) =>
  api.delete(`/addresses/${id}`, createRequestHeadersConfig(token))

export const getInvoiceAddresses = (token: string) =>
  api.get<NestedApiResponse<CustomerInvoiceAddress[]>>(
    `/addresses/invoice`,
    createRequestHeadersConfig(token)
  )

export const getDeliveryAddresses = (token: string) => {
  return api.get<NestedApiResponse<CustomerAddress[]>>(
    `/addresses/delivery`,
    createRequestHeadersConfig(token)
  )
}

export const getInvoiceAddressesQuery = async (token: string) => {
  const response = await getInvoiceAddresses(token)

  return response.data.data
}

export const addInvoiceAddress = (
  payload: CustomerInvoiceAddressPayload,
  token?: string
) =>
  api.post<CustomerInvoiceAddress>(
    '/addresses',
    payload,
    createRequestHeadersConfig(token)
  )

export const editInvoiceAddress = (
  id: string,
  payload: CustomerInvoiceAddressPayload,
  token?: string
) =>
  api.patch<CustomerInvoiceAddress>(
    `/addresses/${id}`,
    payload,
    createRequestHeadersConfig(token)
  )

export const deleteInvoiceAddress = (id: string, token?: string) =>
  api.delete(`/addresses/${id}`, createRequestHeadersConfig(token))
